// extracted by mini-css-extract-plugin
export default {"pageHeroWrapper":"swiupD","heroContent":"PGsbSs","heroIconItemsContainer":"hYqNxP"};